import { useReducer } from "react";
import { createLocalAction } from "../../_common/tools/ui-state.tools";
export function initializeLocalState({ showMyProfile, }) {
    const initialState = { showMyProfile };
    return useReducer(localReducer, initialState);
}
/* end STATE */
export function localReducer(state, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ type, payload }) {
    switch (type) {
        case AuthenticatedFrameActionType.setShowMyProfile:
            return Object.assign(Object.assign({}, state), { showMyProfile: payload.showMyProfile });
        default:
            return state;
    }
}
/* ACTIONS */
export var AuthenticatedFrameActionType;
(function (AuthenticatedFrameActionType) {
    AuthenticatedFrameActionType["setShowMyProfile"] = "setShowMyProfile";
})(AuthenticatedFrameActionType || (AuthenticatedFrameActionType = {}));
export const setShowMyProfile = createLocalAction(AuthenticatedFrameActionType.setShowMyProfile);
/* end ACTIONS */
